module.exports = __webpack_public_path__ + "img/ic-arrow-left.42db3e02.svg";